import React from 'react';

/**
 * MobileNavBar Component
 * Bottom tab navigation for mobile view switching between Categories, Notes, and Editor
 *
 * @param {Object} props
 * @param {string} props.activeView - Current active view ('categories' | 'notes' | 'editor')
 * @param {Function} props.setActiveView - Function to change the active view
 */
const MobileNavBar = ({ activeView, setActiveView }) => {
  const tabs = [
    { id: 'categories', label: 'Categories', icon: '📁' },
    { id: 'notes', label: 'Notes', icon: '📝' },
    { id: 'editor', label: 'Editor', icon: '✏️' }
  ];

  const styles = {
    navbar: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      height: '60px',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      background: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      borderTop: '1px solid rgba(0, 0, 0, 0.1)',
      boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)',
      zIndex: 1000,
      WebkitTapHighlightColor: 'transparent'
    },
    tab: {
      appearance: 'none',
      border: 'none',
      background: 'transparent',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '44px',
      padding: '8px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      textDecoration: 'none',
      WebkitTapHighlightColor: 'transparent',
      userSelect: 'none'
    },
    activeTab: {
      color: '#04658f',
      borderTop: '2px solid #08bce8',
      background: '#eaf8fe',
      fontWeight: '600'
    },
    inactiveTab: {
      color: '#666',
      borderTop: '2px solid transparent'
    },
    icon: {
      fontSize: '20px',
      marginBottom: '4px'
    },
    label: {
      fontSize: '12px',
      fontWeight: 'inherit'
    }
  };

  const handleTabClick = (tabId) => {
    setActiveView(tabId);
  };

  return (
    <nav style={styles.navbar} role="navigation" aria-label="Mobile navigation">
      {tabs.map((tab) => {
        const isActive = activeView === tab.id;
        const tabStyle = {
          ...styles.tab,
          ...(isActive ? styles.activeTab : styles.inactiveTab)
        };

        return (
          <button
            key={tab.id}
            style={tabStyle}
            onClick={() => handleTabClick(tab.id)}
            aria-label={`Switch to ${tab.label} view`}
            aria-current={isActive ? 'page' : undefined}
            type="button"
          >
            <span style={styles.icon}>{tab.icon}</span>
            <span style={styles.label}>{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default MobileNavBar;
